import Select from "../../components/solid-forms/Select";
import IconSearch from "../../components/icons/IconSearch";

const STATUS_OPTIONS = [
    { id: 1, name: "Опубліковано" },
    { id: 0, name: "Чернетка" },
];

const SORT_OPTIONS = [
    { id: "newest", name: "Спочатку нові" },
    { id: "oldest", name: "Спочатку старі" },
    { id: "name", name: "За назвою" },
];

// Select.jsx's placeholder <option> has no value attribute, so selecting it
// yields the placeholder's own label text as e.target.value, not "". Guard
// against that turning into Number("...") = NaN filter state.
function parseOptionId(value) {
    if (value === "") return "";
    const parsed = Number(value);
    return Number.isNaN(parsed) ? "" : parsed;
}

export default function ConversationFilters({
    conversationType,
    onConversationTypeChange,
    conversationTypes,
    level,
    onLevelChange,
    levels,
    isPublic,
    onIsPublicChange,
    search,
    onSearchChange,
    sort,
    onSortChange,
}) {
    return (
        <div className="conv-filters-bar">
            <Select
                options={conversationTypes}
                info="Тип розмови"
                handleInputChange={(value) => onConversationTypeChange(parseOptionId(value))}
                className="submit-field form-selection txt-c select-modal"
                fieldName="name"
                disabled={false}
                value={conversationType}
                inputName="conversationtype"
            />

            <Select
                options={levels}
                info="Рівень"
                handleInputChange={(value) => onLevelChange(parseOptionId(value))}
                className="submit-field form-selection txt-c select-modal"
                fieldName="name"
                disabled={false}
                value={level}
                inputName="level"
            />

            <Select
                options={STATUS_OPTIONS}
                info="Статус"
                handleInputChange={(value) => onIsPublicChange(parseOptionId(value))}
                className="submit-field form-selection txt-c select-modal"
                fieldName="name"
                disabled={false}
                value={isPublic}
                inputName="ispublic"
            />

            <Select
                options={SORT_OPTIONS}
                info="Сортування"
                handleInputChange={(value) => onSortChange(value)}
                className="submit-field form-selection txt-c select-modal"
                fieldName="name"
                disabled={false}
                value={sort}
                inputName="sort"
            />

            <div className="conv-filters-search">
                <IconSearch />
                <input
                    className="conv-filters-search-input"
                    placeholder="Пошук за назвою чи описом..."
                    value={search}
                    onChange={(e) => onSearchChange(e.target.value)}
                />
                {search ? (
                    <div className="conv-filters-search-clear" onClick={() => onSearchChange("")}>
                        ×
                    </div>
                ) : (
                    ""
                )}
            </div>
        </div>
    );
}
